
const messages = {
  sk: {
    errors: {
      required: 'Nesmie byť prázdne.',
      decimal: 'Musí byť číslo.',
      numeric: 'Nesmie byť písmeno.',
      containsLetter: 'Nesmie byť písmeno.',
      containsNumber: 'Nesmie byť číslo.',
      mustCheck: 'Nesmie byť prázdne.',
      checkYear: 'Rok musí byť medzi 95-20',
      checkRcFormat: 'Požadovaný formát: xxxxxx/yyyy',
      checkMonth: 'Neplatné rodné číslo!',
      checkDay: 'Neplatné rodné číslo!',
      maxLength: 'Môže obsahovať najviac {max} znakov.',
      minLength: 'Môže obsahovať najmenej {min} znakov.',
      validRodne: 'Neplatné rodné číslo!',
      minValue: 'Minimálna hodnota 0.',
      minPriloh: 'Minimálna hodnota {min}.',
      maxValue: 'Nesmie byť vyšší ako {max}.', // rok musi bit mensi ako 20, musi byt vacsi ako 94
      maxValueToPrijmy: 'Výdavky sa uvádzajú len do výšky príjmov',
      maxZdanToPrijmy: 'Zaplatená daň sa uvádzajú len do výšky príjmov',
      email: 'Neplatné e-mail formát!',
      urokRequired: "Ak je pole 'Pocet mesiacov' vyplnené potom vyplnenie pola 'Zaplatené úroky' je povinné.",
      mesiaceRequired: "Ak je pole 'Zaplatené úroky' vyplnené potom vyplnenie pola 'Pocet mesiacov' je povinné.",
      requiredIf: 'Nevyplnte Odvody, ak máte vyplnené: Sociálne poistenie, Zdravotné poistenie',
      dicNarodenia: 'Udajte DIČ ALEBO Rodné číslo (len jeden z nich).',
    },
    message: {
      lblzdanitelnePrijmy612: 'Zdaniteľné príjmy (výnosy) z podnikania a z inej samostatnej zárobkovej činnosti',
      butNewDan: 'Vytvorenie nového daňového priznania',
      butSearch: 'vyhľadávanie',
      butNext: 'ďalej',
      butBack: 'späť',
      butPoucenie: 'Zobraziť poučenie k vyplneniu DP',
      wizPage1: 'štart',
      wizPage2: 'Daňové priznanie',
      wizPage3: 'Údaje o daňovníkovi',
      wizPage4: 'Príjmy/výdavky',
      wizPage5: 'stiahnuť',
      createDanTitle: 'Daňovník',
      lblRok: 'Rok',
      lblTyp: 'Typ',
      lblPriez: 'Priezvisko',
      lblMeno: 'Meno',
      lblDic: 'DIČ',
      lblRc: 'Rodné číslo',
      msgNotFound: 'Hľadaný údaj neexistuje.',
      helpNewDan: 'V tomto kroku stlačením na ikonu  „VYTVORENIE NOVÉHO DAŇOVÉHO PRIZNANIA“ môžete vyhotoviť nové daňové priznanie, výberom zo zoznamu môžete upravovať už existujúce daňové priznania.',
      helpCopyDan: 'V prípade, ak chcete použiť údaje existujúceho daňovníka (napr. z daňového priznania, ktoré ste spracovali v predchádzajúcom zdaňovacom období) vyhľadajte si tohto daňovníka v zozname daňovníkov (v tabuľke) a nastavte sa kurzorom myši na riadku s jeho menom vpravo tak, aby sa Vám zobrazila ikona s názvom PRENOS ÚDAJOV. Po kliknutí na túto ikonu sa Vám automaticky vytvorí daňové priznanie na aktuálne zdaňovacie obdobie s prenesenými základnými údajmi tak, aby ste ich nemuseli znova vypĺňať.',
      msgSelectDan: 'K pokračovaniu vyberte daňovníka!',
      lblDan: 'daňovník',
      lblPredlzenie: 'Predĺžení lehoty na podanie daňového priznania',
      menuDan: 'na daňovníka',
      menuManzel: 'na Manžel / manželka',
      menuDeti: 'vyživované deti',
      menuPoukaz: 'Poukázanie podielu zaplatenej dane ( 2% / 3%)',
      menuOsobitne: 'Osobitné záznamy',
      menuZastupca: 'zákonný zástupca',
      zDBonus: 'Zníženie/zvýšenie základu dane a daňové bonusy',
      lblDruh: 'Druh',
      lblDatumZistenia: 'Dátum zistenia skutočnosti na podanie dodatočného daňového priznania',
      lblBirthday: 'Dátum narodenia',
      lblNace: 'Sk-nace',
      ksDetiHint: 'Preukázateľne zaplatené úhrady na kúpelnú starostlivosť za vyživované dieťa (deti) v úhrne najviac do výšky 50 eur za rok za každé z týchto detí.',
      msgSelect: 'Výber zo zoznamu..',
      lblStat: 'Štát',
      lblAdresaPobytu: 'Adresa pobytu na území Slovenskej republiky, kde sa daňovník obvykle zdržiaval v zdaňovacom období',
      lblDochodca: 'Dôchodca',
      lblPandemicke: 'Spĺňam podmienky na uplatnenie "pandemického" daňového bonusu podľa § 24aa zákona č. 67/2020 Z. z. v zn. n. p',
      lblSumDoch: 'Suma dôchodku',
      lblNerezident: 'Daňovník s obmedzenou daňovou povinnosťou (nerezident) podľa § 2 písm. e)',
      lblStatRez: 'Štát daňovej rezidencie',
      lblUhrnPrijm: 'Nerezident: záhranične príjmy',
      lblPrepojenie: 'Ekonomické, personálne alebo iné prepojenie',
      lblSave: 'Uložiť',
      lblDelete: 'Vymazať',
      lblDanPriz: 'daňové priznanie',
      lblDodDanPriz: 'dodatočné daňové priznanie',
      lblCreateDod: 'vytvor dodatočné',
      lblTitulP: 'Titul pred menom',
      lblTitulZ: 'Titul za menom',
      lblUlica: 'Ulica',
      lblCislo: 'Súpisné/Orientačné číslo',
      lblPsc: 'PSČ',
      lblObec: 'Obec',
      lblTel: 'Telefónne číslo',
      lblMail: 'E-mail',
      lblIban: 'IBAN',
      lblPocPril: 'Počet príloh',
      lblDatumVyhlasenia: 'Dátum podania daňového priznania',
      lblPorusPod: 'Zvýšenie základu dane',
      lblKs: 'Zaplatené úhrady na kúpeľná starostlivosť',
      lblDds: 'DDS',
      lblUver: 'Výška úveru na bývanie',
      hintPrispevky: 'Preukázateľne zaplatené príspevky na doplnkové dôchodkové sporenie',
      lblUroky: 'Zaplatené úroky v roku 2020',
      lblUzatvorenie: 'Dátum uzatvorenia zmluvy',
      lblMesiac: 'Počet mesiacov',
      lblRekreaciaValue: 'Výška príspevku na rekreáciu',
      rekreaciaInfo: 'Daňovník s príjmami podľa §6 ods.1 a 2 ZDP vykonávajúci podnikanie alebo SZČ min. 24 mesiacov si môže uplatniť príspevok na rekreáciu vo výške 55% oprávnených výdavkov, max. 275 €.',
      oznamenie: {
        header: "Daňovník vyznačí, podľa ktorého ustanovenia zákona si predlžuje lehotu na podanie daňového priznania a uvedie novú (predĺženú) lehotu.",
        cbPismA: "predĺženie lehoty podľa § 49 ods. 3 písm. a) zákona (najviac o tri celé kalendárne mesiace)",
        cbPismB: "predĺženie lehoty podľa § 49 ods. 3 písm. b) zákona (najviac o šesť celých kalendárnych mesiacov, ak súčasťou príjmov daňovníka sú zdaniteľné príjmy plynúce zo zdrojov v zahraničí)",
        dtpLehota: "nová lehota"
      },
      tooltipManzel: 'Do vlastného príjmu manželky (manžela) sa nezahŕňa zamestnanecká prémia podľa § 32a zákona, daňový bonus podľa § 33 zákona, zvýšenie dôchodku pre bezvládnosť, štátne sociálne dávky a štipendium poskytované študujúcim sústavne sa pripravujúcim na budúce povolanie, pričom vlastný príjem manželky (manžela) sa znižuje o zaplatené poistné a príspevky, ktoré manželka (manžel) v príslušnom zdaňovacom období bola (bol) povinná z tohto príjmu zaplatiť [§ 11 ods. 4 písm. b) zákona]. Do vlastného príjmu manželky (manžela) patria okrem zdaniteľných príjmov napr. aj nemocenské dávky (napr. materské), dôchodkové dávky (napr. starobný dôchodok), ďalej dávka v nezamestnanosti, peňažný príspevok na opatrovanie, dávka v hmotnej núdzi, rôzne ďalšie sociálne dávky a pod.',
      lblPriezMeno: 'Priezvisko a meno',
      lblVlstPrijmy: 'Vlastné príjmy',
      lblAddDieta: 'pridať dieťa',
      lblUhrnSuma: 'Úhrnna suma zaplatených úhrad na kúpelnú starostlivosť za vyživované deti',
      ks: 'Kúpeľná starostlivosť',
      lblDanBonus: 'Daňový bonus',
      lblMesiace: 'Mesiace',
      lblDieta: 'Dieťa č.',
      lblPocMesiac: 'Počet mesiacov',
      h3Udaje: 'Údaje o prijímateľovi',
      lblPercent: 'Percent: ',
      lblSuhlasim: 'Súhlasím so zaslaním údajov',
      helpPercent: 'Podiel do výšky 3 % dane podľa § 50 ods. 1 písm. a) zákona môže prijímateľovi poukázať fyzická osoba, ktorá v zdaňovacom období vykonávala dobrovoľnícku činnosť podľa zákona č. 406/2011 Z.z. o dobrovoľníctve a o zmene a doplnení niektorých zákonov v znení zákona č. 440/2015 Z.z. počas najmenej 40 hodín, pričom kópia písomného potvrdenia o výkone tejto činnosti je prílohou daňového priznania.',
      lblNeuplatnuje: 'Neuplatňuje postup',
      lblPercent1: '2%',
      lblPercent2: '3%',
      lblIco: 'IČO',
      lblPravnaForma: 'Právna forma',
      lblObchMeno1: 'Obchodné meno riadok 1',
      lblObchMeno2: 'Obchodné meno riadok 2',
      lblNumber: 'Číslo',
      lgndZastupca: 'Daňové priznanie podáva za daňovníka zákonný zástupca',
      lblAddRow: 'pridať riadok',
      lblUP: 'Úhrn príjmov',
      lblZTDohody: 'Z toho dohody',
      lblSoc: 'Sociálne poistenie',
      lblZdr: 'Zdravotné poistenie',
      lblVypDanBonus: 'Vyplatený daňový bonus',
      lblPreddavky: 'Preddavky na daň §35',
      lblPrijem: 'Príjem č.',
      lblPrijmy: 'Príjmy',
      lblVydavky: 'Výdavky',
      lblPrijmyZaplatene: 'Príjmy boli v zahraničí zdanené',
      lblKraj: 'Krajina',
      lblKurz: 'Kurz',
      pTuz52: 'Údaje uvádzajte v mene, v ktorej Vám boli príjmy vyplatené; prepočet na menu EUR sa uskutoční automaticky.',
      pTuz5: 'Ak nie je možné rozdeliť poistné na sociálne resp. na zdravotné poistenie  vyplní sa len kolónka „odvody“.',
      lblOdvody: 'Odvody',
      lblOsAsist: 'Osobná asistencia',
      lblSposobUct: 'Spôsob účtovania',
      lblJeUc: 'jednoduché účtovníctvo',
      lblVyPercent: 'výdavky percentom',
      lblDanEvid: 'daňová evidencia',
      msgNastavHodnot: 'Nastavte hodnotu:',
      druhMenu1: 'z poľnohospodárskej výroby, lesného a vodného hospodárstva',
      druhMenu2: 'zo živnosti',
      druhMenu3: 'z podnikania vykonávaného podľa osobitných predpisov',
      druhMenu4: 'spoločníkov v. o. s. a komplementárov kom. spol.',
      druhMenu5: 'z vytvorenia diela a umeleckého výkonu a z použitia alebo poskytnutia práv z priemyselného alebo iného duševného vlastníctva',
      druhMenu6: 'z činností, ktoré nie sú živnosťou ani podnikaním',
      druhMenu7: 'znalcov a tlmočníkov za činnosť podľa osobitného predpisu',
      druhMenu8: 'z činností sprostredkovateľov, ktoré nie sú živnosťou',
      druhMenu9: 'z činnosti športovca alebo športového odborníka podľa osobitného predpisu vrátane príjmov na základe zmluvy o sponzorstve v športe',
      lblTuz6Row: 'Tuzemský príjem podľa § 6 ods.1,2 č.',
      lblDruhPrijmov: 'Druh príjmov',
      zaplPrispevkyHeader: 'Daňový bonus na zaplatené úroky',
      lblMetoda: 'Metóda zamedzenia dvojitého zdanenia',
      lblDanZaplatena: 'Daň zaplatená v zahraničí',
      metodaV: 'vyňatia príjmov',
      metodaZ: 'zápočtu dane',
      lblOslobodene: 'Oslobodené príjmy z prenájmu nehnuteľností ',
      helpNehnPrijmy: 'Je potrebné zmeniť túto sumu, ak si daňovník uplatnil oslobodenie od dane pri iných druhoch príjmov (príjmy z príležitostných činností vrátane príjmov z príležitostnej poľnohospodárskej výroby, lesného a vodného hospodárstva a z príležitostného prenájmu hnuteľných vecí, príjmy z prevodu opcií, príjmy z prevodu cenných papierov, príjmy z prevodu účasti (podielu) na spoločnosti s ručením obmedzeným, komanditnej spoločnosti alebo z prevodu členských práv družstva)',
      tuz6o3Info: 'Uvádzajú sa príjmy a výdavky v skutočnej výške (tzn. pred odpočítaním o oslobodené príjmy) a následné prepočty sú automatické.',
      lblR10p: 'Príjmy z prenájmu nehnuteľností',
      lblR10v: 'Výdavky z prenájmu nehnuteľností',
      druhPrenajNehnut: 'z prenájmu nehnuteľností',
      lblTuz64p: 'Príjmy z použitia diela a umeleckého výkonu, ak nepatria do príjmov podľa § 6 ods. 2 písm. a) zákona uvádzaných na r. 5',
      lblTuz64v: 'Výdavky z použitia diela a umeleckého výkonu, ak nepatria do príjmov podľa § 6 ods. 2 písm. a) zákona uvádzaných na r. 5',
      lblUrokP: 'Úrokový príjem',
      lblZaplDan: 'Zaplatená daň',
      lblPrijmyDosiahnute: 'príjmy dosiahnuté z vyplatenia (vrátenia) podielových listov..',
      plchZrD: 'zrážková daň',
      tuz7r1: 'úroky a ostatné výnosy z cenných papierov',
      tuz7r2: 'úroky, výhry a iné výnosy z vkladov na vkladných knižkách..',
      tuz7r3: 'úroky a iné výnosy z poskytnutých úverov a pôžičiek..',
      tuz7r4: 'dávky z doplnkového dôchodkového sporenia',
      tuz7r5: 'plnenia z poistenia pre prípad dožitia určitého veku; ..',
      tuz7r6: 'výnosy zo zmeniek okrem príjmov z ich predaja',
      tuz7r7: 'príjmy z podielových listov dosiahnuté z ich vyplatenia (vrátenia)',
      tuz7r8: 'výnosy zo štátnych dlhopisov a štátnych pokladničných poukážok',
      tuz7r9: 'výnos, ktorý vzniká pri splatnosti cenného papiera z rozdielu medzi..',
      tuz7r10: 'rozdiel medzi menovitou hodnotou dlhopisu alebo..',
      lblR16p: 'kladný rozdiel medzi vyššou hodnotou nepeňažného vkladu započítanou na vklad spoločníka a hodnotou vkladaného majetku',
      tuz8r1: 'z príležitostných činností vrátane príjmov z príležitostnej poľnohospodárskej výroby..',
      tuz8r2: 'z prevodu vlastníctva nehnuteľností',
      tuz8r3: 'z predaja hnuteľných vecí',
      tuz8r4: 'z prevodu opcií',
      tuz8r5: 'z prevodu cenných papierov',
      tuz8r6: 'z prevodu účasti (podielu) na s. r. o., kom. spol. alebo..',
      tuz8r7: 'zo zdedených práv z priemyselného a iného duševného vlastníctva vrátane..',
      tuz8r8: 'dôchodky a podobné opakujúce sa požitky',
      tuz8r9: 'výhry a ceny',
      tuz8r10: 'príjmy z derivátových operácií',
      tuz8r11: 'peňažné a nepeňažné plnenie prijaté pri výkone klinického skúšania..',
      tuz8r12: 'náhrada nemajetkovej ujmy, okrem náhrady nemajetkovej ujmy, ktorá bola spôsobená trestným činom',
      tuz8r13: 'na základe zmluvy o sponzorstve v športe, prijaté športovcom podľa osobitného predpisu',
      tuz8r14: 'náhrada za stratu času dobrovoľníka zapísaného v informačnom systéme športu podľa osobitného predpisu',
      tuz8r15: 'príjmy z prerozdelenia kapitálového fondu z príspevkov',
      tuz8r16: 'príjmy z predaja virtuálnej meny',
      tuz8r17: 'iné',
      lblTab1a: 'Tabuľka č. 1a',
      lblTab1b: 'Tabuľka č. 1b',
      lblTabZac: 'Na začiatku zdaňovacieho obdobia',
      lblTabKonc: 'Na konci zdaňovacieho obdobia',
      msgTabNoSposob: 'Podľa zadaných kritériach - spôsob účtovania - nie je potrebné vyplniť tabuľku č. 1a resp 1b',
      lblHmotneMajetok: 'Zostatková cena hmotného majetku zaradeného do obchodného majetku',
      lblNehmotneMajetok: 'Zostatková cena nehmotného majetku zaradeného do obchodného majetku',
      lblZasoby: 'Zásoby',
      lblPohladavky: 'Pohľadávky',
      lblZavazky: 'Záväzky',
      downloadHelp1: 'UPOZORNENIE: Ak sa Vám po otvorení pdf dokumentu vo Vašom webovom prehliadači nezobrazuje korektne diakritika, súbor si uložte do svojho počítača (napr. na plochu) a znovu ho otvorte priamo z Vášho počítača.',
      lblPredNaDan: 'Preddavky na daň z príjmov FO',
      lblReport: 'REPORT',
      ekonomickeHelp: 'Z usmernenia MF SR č. MF/019153/2018-724 o určení obsahu dokumentácie, ktoré nahrádza pôvodné usmernenie z roku 2016 a prvýkrát je možné podľa neho postupovať pri predložení dokumentácie za zdaňovacie obdobie začínajúce po 31.12.2017, vyplýva, že v prípadenevýznamných (§ 17 ods. 9 ZoÚ) kontrolovaných transakcií medzi závislými osobami je povinnosť vedenia transferovej dokumentácie (§18 ods. 1 ZDP) splnená podaním riadne vyplneného daňového priznania k dani z príjmov za príslušné zdaňovacie obdobie, tzn. ak tieto nevýznamné kontrolované transakcie budú uvedené v oddieli miesto na osobitné záznamy daňovníka. ',
      linkToFinancna: 'Prehľad metód zamedzenia dvojitého zdanenia je dostupný tu:',
      financnaLink: 'https://www.financnasprava.sk//_img/pfsedit/Dokumenty_PFS/Zverejnovanie_dok/Dane/Zamedzenie_dvojiteho_zdan/2014.06.12_metody_zdz.pdf',
      lblSuhlas: 'Súhlasím s obchodnými podmienkami',

      // poistne
      soc_zaplatene: 'Sociálne poistenie - zaplatené',
      soc_dobrovolne: 'z toho dobrovoľné sociálne poistenie',
      zdrav_zaplatene: 'Zdravotné poistenie - zaplatené',
      zdrav_zdan_obdobie: 'z toho zdravotné poistenie príslušné k aktuálnému zdaňovaciemu obdobiu',

      // preddavky
      preddavky44: 'Podľa §44 zákona - na zabezpečenie dane',
      preddavky34okrem6a7: 'Podľa §34 okrem podľa §34 ods. 6 a 7 zákona',
      preddavkyHint: 'preddavky na daň platené podľa § 5 a § 6 ZDP z posledného daňového priznania',
      preddavky34ods67: 'Podľa §34 ods. 6 a 7 zákona',
      tooltipPreddavky: 'Do tejto sumy sa uvádzajú aj preddavky, ktoré daňovník uhradil po skončení zdaňovacieho obdobia, do lehoty na podanie daňového priznania, ak sa vzťahujú k daňovej povinnosti za zdaňovacie obdobie, za ktoré sa daňové priznanie podáva. Rovnako súčasťou tejto sumy je aj preplatok použitý na úhradu preddavkov. Do tejto sumy sa nezapočítavajú preddavky platené daňovníkom na budúce zdaňovacie obdobie.',

      // strata
      strata_col1: 'Daňové straty vykázané za zdaňovacie obdobia ukončené v rokoch 2010 až 2013',
      strata_col2: 'Daňové straty z predchádzajúcich zdaňovacích období odpočítavané podľa § 30 zákona',
      // from 2020
      strata_inputs: {
        vykStraty: 'Suma vykázanej daňovej straty',
        strata24b: 'Suma daňovej straty, ktorá bola odpočítaná podľa § 24b zákona č. 67/2020 Z.z.',
        strata30and52podla24b: 'Zostatok z r. 2 po zohľadnení daňovej straty podľa § 30 a § 52zza ods. 16 zákona a podľa § 24b zákona č. 67/2020 Z.z.',
        strata30and52: 'Suma odpočítavanej daňovej straty podľa § 30 a § 52zza ods. 16 zákona'
      },
      // sposobZahrnovania
      uplatnuje: 'Uplatňujem osobitný spôsob zahrnovania kurzových rozdielov do základu dane podľa § 17 ods. 17 zákona',
      u_p6ods1a2: 'pri príjmoch podľa § 6 ods. 1,2',
      u_p6ods4: 'pri príjmoch podľa § 6 ods. 4',
      ukoncuje: 'Ukončujem uplatňovanie osobitného spôsobu zahrnovania kurzových rozdielov do základu dane podľa § 17 ods. 17 zákona',
    },
  },
};
export default messages;
